import React from 'react';
import { StarIcon, ShieldCheckIcon, BadgeCheckIcon } from 'lucide-react';
export function Testimonials() {
  return <section className="mb-12" data-id="element-414">
      <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-2 text-center" data-id="element-415">
        Vad säger andra om Brainy?
      </h2>
      <p className="text-center mb-6 text-gray-600 text-sm" data-id="element-416">
        <span className="italic" data-id="element-417">
          Dessa är verifierade köpare som har använt Brainy i minst 30 dagar
        </span>
      </p>
      <div className="flex items-center justify-center mb-6" data-id="element-418">
        <div className="flex" data-id="element-419">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-6 w-6 text-yellow-500 fill-current" data-id="element-420" />)}
        </div>
        <div className="ml-2 text-lg font-semibold" data-id="element-421">4.9/5</div>
        <div className="ml-2 text-sm text-gray-600" data-id="element-422">
          (baserat på 3,487 verifierade recensioner)
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-423">
        <div className="bg-white p-5 rounded-lg shadow-md relative" data-id="element-424">
          <div className="absolute top-2 right-2" data-id="element-425">
            <BadgeCheckIcon className="h-5 w-5 text-blue-500" data-id="element-426" />
          </div>
          <div className="flex items-center mb-3" data-id="element-427">
            <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Eva" className="w-12 h-12 rounded-full mr-3 object-cover" data-id="element-428" />
            <div data-id="element-429">
              <div className="flex items-center" data-id="element-430">
                <h3 className="font-semibold" data-id="element-431">Eva, 36 år</h3>
                <span className="ml-2 text-xs text-gray-500" data-id="element-432">
                  Verifierad köpare
                </span>
              </div>
              <div className="flex text-yellow-500" data-id="element-433">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-434" />)}
              </div>
            </div>
          </div>
          <p className="italic mb-2" data-id="element-435">
            "Som småbarnsmamma och företagare kände jag mig konstant utmattad
            och glömsk.{' '}
            <span className="font-medium text-amber-800" data-id="element-436">
              Min chef antydde att jag 'verkade frånvarande' på möten.
            </span>{' '}
            Efter att ha tagit Brainy i en månad känner jag mig skarpare och kan
            äntligen hålla flera bollar i luften utan att tappa fokus!"
          </p>
          <div className="text-xs text-gray-500" data-id="element-437">Recenserad 14 dagar sedan</div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md relative" data-id="element-438">
          <div className="absolute top-2 right-2" data-id="element-439">
            <BadgeCheckIcon className="h-5 w-5 text-blue-500" data-id="element-440" />
          </div>
          <div className="flex items-center mb-3" data-id="element-441">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXfAv8NFczs1R5oZdHP5xQ/bengt67.webp" alt="Bengt" className="w-12 h-12 rounded-full mr-3 object-cover" data-id="element-442" />
            <div data-id="element-443">
              <div className="flex items-center" data-id="element-444">
                <h3 className="font-semibold" data-id="element-445">Bengt, 67 år</h3>
                <span className="ml-2 text-xs text-gray-500" data-id="element-446">
                  Verifierad köpare
                </span>
              </div>
              <div className="flex text-yellow-500" data-id="element-447">
                {[...Array(4)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-448" />)}
                <StarIcon className="h-4 w-4 text-gray-300" data-id="element-449" />
              </div>
            </div>
          </div>
          <p className="italic mb-2" data-id="element-450">
            "Efter pensioneringen märkte jag att mitt minne började svikta.{' '}
            <span className="font-medium text-amber-800" data-id="element-451">
              Min fru fick upprepa saker flera gånger, och jag såg oron i hennes
              ögon.
            </span>{' '}
            Brainy har hjälpt mig att känna mig mentalt skarp igen. Nu kan jag
            njuta av pensionärslivet utan oro!"
          </p>
          <div className="text-xs text-gray-500" data-id="element-452">Recenserad 28 dagar sedan</div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md relative" data-id="element-453">
          <div className="absolute top-2 right-2" data-id="element-454">
            <BadgeCheckIcon className="h-5 w-5 text-blue-500" data-id="element-455" />
          </div>
          <div className="flex items-center mb-3" data-id="element-456">
            <img src="https://images.unsplash.com/photo-1588516903720-8ceb67f9ef84?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Kristina" className="w-12 h-12 rounded-full mr-3 object-cover" data-id="element-457" />
            <div data-id="element-458">
              <div className="flex items-center" data-id="element-459">
                <h3 className="font-semibold" data-id="element-460">Kristina, 53 år</h3>
                <span className="ml-2 text-xs text-gray-500" data-id="element-461">
                  Verifierad köpare
                </span>
              </div>
              <div className="flex text-yellow-500" data-id="element-462">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-463" />)}
              </div>
            </div>
          </div>
          <p className="italic mb-2" data-id="element-464">
            "Klimakteriet påverkade inte bara min kropp utan också mitt minne
            och koncentrationsförmåga.{' '}
            <span className="font-medium text-amber-800" data-id="element-465">
              Jag började undra om jag skulle bli en börda för min familj i
              framtiden.
            </span>{' '}
            Brainy har hjälpt mig att ta tillbaka kontrollen över mitt liv och
            min hjärna. Jag känner mig som mig själv igen!"
          </p>
          <div className="text-xs text-gray-500" data-id="element-466">
            Recenserad 2 månader sedan
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md relative" data-id="element-467">
          <div className="absolute top-2 right-2" data-id="element-468">
            <BadgeCheckIcon className="h-5 w-5 text-blue-500" data-id="element-469" />
          </div>
          <div className="flex items-center mb-3" data-id="element-470">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Tore" className="w-12 h-12 rounded-full mr-3 object-cover" data-id="element-471" />
            <div data-id="element-472">
              <div className="flex items-center" data-id="element-473">
                <h3 className="font-semibold" data-id="element-474">Tore, 47 år</h3>
                <span className="ml-2 text-xs text-gray-500" data-id="element-475">
                  Verifierad köpare
                </span>
              </div>
              <div className="flex text-yellow-500" data-id="element-476">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-477" />)}
              </div>
            </div>
          </div>
          <p className="italic mb-2" data-id="element-478">
            "Som IT-konsult måste jag vara skarp och fokuserad hela dagen. Efter
            40 började jag märka att jag inte kunde hålla samma tempo.{' '}
            <span className="font-medium text-amber-800" data-id="element-479">
              Jag var rädd att yngre kollegor skulle ta över mina projekt.
            </span>{' '}
            Brainy har hjälpt mig att återfå min mentala uthållighet och
            prestationsförmåga på jobbet."
          </p>
          <div className="text-xs text-gray-500" data-id="element-480">
            Recenserad 3 månader sedan
          </div>
        </div>
      </div>
      <div className="mt-8 bg-white p-4 rounded-lg shadow-md" data-id="element-481">
        <div className="flex items-start" data-id="element-482">
          <div className="mr-4" data-id="element-483">
            <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=120&q=80" alt="Dr. Erik Johansson" className="w-16 h-16 rounded-full object-cover" data-id="element-484" />
          </div>
          <div data-id="element-485">
            <div className="flex items-center mb-1" data-id="element-486">
              <h3 className="font-bold text-gray-800" data-id="element-487">Dr. Erik Johansson</h3>
              <ShieldCheckIcon className="h-4 w-4 text-blue-500 ml-1" data-id="element-488" />
            </div>
            <p className="text-sm text-gray-600 mb-2" data-id="element-489">
              Neurolog, Docent i Neurokemi
            </p>
            <p className="italic text-gray-700" data-id="element-490">
              "Som neurolog ser jag dagligen patienter som oroar sig över
              minnesproblem. Det tragiska är att när de väl kommer till mig har
              processen ofta pågått i åratal.{' '}
              <span className="font-medium" data-id="element-491">
                Vad de flesta inte förstår är att hjärnan behöver specifika
                näringsämnen för att upprätthålla optimal funktion, särskilt
                efter 40.
              </span>{' '}
              Brainy innehåller exakt de näringsämnen som vetenskaplig forskning
              visar är avgörande för kognitiv hälsa."
            </p>
            <div className="text-xs text-gray-500 mt-2" data-id="element-492">
              *Dr. Johansson är konsulterande expert för Brainy
            </div>
          </div>
        </div>
      </div>
    </section>;
}